import { useEffect } from "react";
import { useAuthStore } from "@/utils/UseAuthStore";
import SharedTemplate from "./SharedTemplate";
import SharedTemplatePublic from "./SharedTemplatePublic";

const SharedTemplateRouter = () => {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn());

  useEffect(() => {
    const isDarkMode = localStorage.getItem("theme") === "dark";
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, []);

  return isLoggedIn ? <SharedTemplate /> : <SharedTemplatePublic />;
};

export default SharedTemplateRouter;
